import { render } from "./ChatbotMain.vue?vue&type=template&id=6877b368"
import script from "./ChatbotMain.vue?vue&type=script&lang=js"
export * from "./ChatbotMain.vue?vue&type=script&lang=js"

import "./ChatbotMain.vue?vue&type=style&index=0&id=6877b368&lang=css"

import exportComponent from "/home/ubuntu/chatbot/chatbot_web/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__